import { lazy, Suspense } from "react";

import { Spinner } from "@app/components/spinners/spinner";

const ImporterDownloadsCenterPageHome = lazy(() => {
  return new Promise<{ default: React.FC }>((resolve, reject) => {
    import("downloads-center/lib")
      .then((lib) => {
        resolve({
          default: () => <lib.default.DownloadsHome />,
        });
      })
      .catch(reject);
  });
});

export const LazyDownloadsCenterPageHome = () => {
  return (
    <Suspense fallback={<Spinner height={"100vh"} />}>
      <ImporterDownloadsCenterPageHome />
    </Suspense>
  );
};
